import angular from 'angular';


const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['$uibModalInstance'],
    required: []
};

export class SeatMapModalWarningsController implements ng.IController {

    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService) {
    }
    accept = (): void => {
        this.$uibModalInstance.close();
    };

    close = (): void => {
        this.$uibModalInstance.dismiss('cancel');
    };


    /**
     * Close or cancel modal
     * @param {*} change
     */
    cancelChangeSeats = (change): void => {
        if (change) {
            this.$uibModalInstance.close();
        } else {
            this.$uibModalInstance.dismiss();
        }
    };
}


try {
    SeatMapModalWarningsController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SeatMapModalWarningsController.name, SeatMapModalWarningsController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SeatMapModalWarningsController.$inject = controllerInfo.inject;
    mod.controller(SeatMapModalWarningsController.name, SeatMapModalWarningsController);
}